
import React, { Component } from "react";
import styled, {css} from "styled-components";
import TableCell from "@material-ui/core/TableCell";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import { SequenceDisplay } from 'core/Display';


const StyledTableCellDescription = styled(TableCell)`
  font-size: 12px;
  min-width: 160px;
  max-width: 300px;
`;

const StyledInfo = styled.div`
  font-size: 12px;
  text-overflow: ellipsis;
  margin-bottom: 5px;
  
  ${props => props.gray && css`
    color: #828282;
  `};
`;

const BindingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;

  > span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .MuiIconButton-root {
    padding: 2px;
    color: #828282;
  }
`;

export default class TableCellDescription extends Component {
  handleClear = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const { item, onClearBinding } = this.props;
    if (onClearBinding) {
      onClearBinding(item);
    }
  };

  render() {
    const { item, onClearBinding, clearDisabled, ...otherProps } = this.props;
    const bindingLabel = [
      item.tractor_unit ? item.tractor_unit_display : undefined,
      item.semi_trailer ? item.semi_trailer_display : undefined,
      item.driver ? item.driver_display : undefined,
    ];
    const hasBinding = Boolean(item.tractor_unit || item.semi_trailer || item.driver || item.schedule);

    return (
      <StyledTableCellDescription {...otherProps}>
        <StyledInfo>
          <BindingRow>
            <span>
              <SequenceDisplay values={bindingLabel} separator={', '} />
            </span>
            {onClearBinding && hasBinding && (
              <IconButton
                size={'small'}
                title={'Убрать связку'}
                disabled={clearDisabled}
                onClick={this.handleClear}
              >
                <ClearIcon fontSize={'small'} />
              </IconButton>
            )}
          </BindingRow>
        </StyledInfo>
        <StyledInfo gray={true}>
          <SequenceDisplay values={[
            item.client?.name,
            item.client?.personal_manager_last_name
          ]} separator={', '} defaults={'Клиент не указан'} />
        </StyledInfo>
      </StyledTableCellDescription>
    )
  }
}
